import { Injectable } from '@angular/core';
import { BehaviorSubject, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MockCallServiceService {
  private popups = new Map<string, any>();
  private popupsSubject = new BehaviorSubject<any[]>([]);

  /** Observable for the components to subscribe to */
  public readonly openedPopups$ = this.popupsSubject.asObservable();

  /** Observable boolean: true if any popup is open */
  readonly isPopupOpen$ = this.openedPopups$.pipe(map(list => list.length > 0));

  constructor() {}

  /** Add a popup (or update if already exists) */
  addPopup(busId: string, popup: any): void {
    if (this.popups.size < 1) {
      this.popups.set(busId, popup);
      this.emitChange();
    }
  }

  /** Remove a popup by busId */
  removePopup(busId: string): void {
    this.popups.delete(busId);
    this.emitChange();
  }

  /** Clear all popups */
  clearAll(): void {
    this.popups.clear();
    this.emitChange();
  }

  private emitChange(): void {
    this.popupsSubject.next(Array.from(this.popups.values()));
  }
}
